import styled from "styled-components";

export const MascotasTableContainer = styled.div`
  .fullWidth {
    width: 95%;
  }
  .halfWidth {
    width: 47%;
  }
  .oneThirdWidth {
    width: 30%;
  }
  .twoThirdWidth {
    width: 69%;
  }

  .coverage-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
  }

  .flex-content-wrapper {
    padding: 0 20px;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .flex-no-wrap {
    flex-wrap: nowrap;
  }
`;
